import Rollup from "./rollup";
import List from "./list";
import IRollup from "../interface/rollup";
import IModuleCard from "../interface/module-card";
import IList from "../interface/list";
import ICardWidget from "../interface/card-widget";
import ErrorCode from "../enum/error-code";
import CardType from "../enum/card-type";
import ModuleCardBase from "../class/module-card-base";

class ModuleCardWidgetInstance extends ModuleCardBase {

    public CardType: CardType = CardType.Widget;

    public async onCreate(card: ICardWidget): Promise<ICardWidget> {
        if (card.rollup) {
            const rollup: IRollup = await Rollup.create(card.label, card.rollup);
            const list: IList = await List.create(card.rollup.entityId, card.label, false);
            card.rollupId = rollup.id;
            card.listId = list.id as number;
            return card;
        } else {
            throw ErrorCode.BadArguments;
        }
    }

    public async onUpdate(card: ICardWidget, existed: ICardWidget): Promise<IModuleCard> {
        if (card.rollup && existed.rollup) {
            card.listId = existed.listId;
            card.rollupId = existed.rollupId;
            card.rollup.id = card.rollupId;
            await Rollup.update(card.rollup);
            // TODO - Handle rollup entityId change (list should point to another entity)
            return card;
        } else {
            throw ErrorCode.BadArguments;
        }
    }

    public async onDelete(card: ICardWidget): Promise<void> {
        await List.delete(card.listId);
        await Rollup.delete(card.rollupId);
    }

    public toClient(card: ICardWidget): ICardWidget | null {
        const rollup: IRollup | null = Rollup.get(card.rollupId);
        const list: IList | null = List.get(card.listId);
        if (rollup && list) {
            card.rollup = rollup;
            return card;
        }
        return null;
    }

    public toServer(card: ICardWidget): ICardWidget {
        return {
            id: card.id,
            type: CardType.Widget,
            label: card.label,
            moduleId: card.moduleId,
            listId: card.listId,
            icon: card.icon,
            rollupId: card.rollupId
        };
    }

    public valid(card: ICardWidget): boolean {
        card.label = card.label.trim();
        return !!card.rollup && !!card.label;
    }

    public getListId(card: ICardWidget): number | null {
        return card.listId;
    }

}

const ModuleCardWidget = new ModuleCardWidgetInstance();

export default ModuleCardWidget;